import { ReassignRecordingRequestSchema, ReassignRecordingResponseSchema } from './reassign-recording.schema';
/**
 * Reassign Recording Endpoint Contract
 * Reassigns a process step recording by finding and rejecting its associated assignment
 * User can mark it as unclear or reassign to another user
 */ export const reassignRecordingContract = {
    method: 'POST',
    path: '/api/v2/process-step-recording/:id/reassign',
    description: 'Reassign a process step recording with reason and optional reassignee',
    requestSchema: ReassignRecordingRequestSchema,
    responseSchema: ReassignRecordingResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Invalid request body, recording not found, or validation error',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user cannot reassign this recording',
            404: 'Recording or associated assignment not found'
        }
    }
};

//# sourceMappingURL=reassign-recording.contract.js.map